import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import { type OtSelectOption } from '@1trading/design-system';
import { useVuelidate } from '@vuelidate/core';
import { required as requiredValidator } from '@vuelidate/validators';
import { computed, reactive, type PropType, useAttrs } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'XSelectMulti',
  props: {
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: true },
  value: { type: Array as PropType<Array<OtSelectOption>>, required: true },
},
  setup(__props) {

const props = __props;

const $attrs = useAttrs();
const { t } = useI18n({ useScope: 'global' });

const dummyCheck = () => true;
const validationRules = {
  internalVModel: { required: props.required ? requiredValidator : dummyCheck },
};

const v = useVuelidate(validationRules, reactive({ internalVModel: props.value }));
const validationErrorMessages = computed(() => ({
  internalVModel: {
    required: t('fundamentals.multiSelect.required'),
  },
}));

const label = computed(() => (typeof $attrs.label === 'string' ? $attrs.label : 'label'));
const selectedValues = computed(() => v.value.internalVModel.$model.map((option) => option[label.value]));

const isOptionSelected = (option: OtSelectOption) => selectedValues.value.includes(option[label.value]);

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_ot_list_item = _resolveComponent("ot-list-item")!
  const _component_ot_select = _resolveComponent("ot-select")!
  const _component_ot_input_error_wrapper = _resolveComponent("ot-input-error-wrapper")!

  return (_openBlock(), _createBlock(_component_ot_input_error_wrapper, {
    error: _unref(v).internalVModel,
    "error-messages": validationErrorMessages.value.internalVModel,
    disabled: __props.disabled
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ot_select, _mergeProps(_unref($attrs), {
        value: _unref(v).internalVModel.$model,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v).internalVModel.$model) = $event)),
        class: "x-select-multi",
        disabled: __props.disabled,
        multiple: true
      }), {
        option: _withCtx((option) => [
          _createVNode(_component_ot_list_item, {
            title: option[label.value],
            variant: _unref($attrs).variant === 'light-outlined' ? 'light' : 'default',
            active: isOptionSelected(option)
          }, {
            "label-additional-content": _withCtx(() => [
              (isOptionSelected(option))
                ? (_openBlock(), _createBlock(_component_ot_icon, {
                    key: 0,
                    class: "x-select-multi__dropdown-option-icon",
                    name: "checkmark",
                    size: "small"
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["title", "variant", "active"])
        ]),
        _: 1
      }, 16, ["value", "disabled"])
    ]),
    _: 1
  }, 8, ["error", "error-messages", "disabled"]))
}
}

})